/**
 * Health Check Status Formatter.
 * @param value
 * @returns {*|string}
 */
window.healthCheckStatusFormatter = function(value) {
    switch (value) {
        case "OK":
            return '<span class="badge rounded-pill" style="display: block; background-color: #D9E6C3; color: #77AB13">'+value+'</span>';
        case "FAILED":
            return '<span class="badge rounded-pill" style="display: block; background-color: #F2D4CE; color: #AE432E">'+value+'</span>';
        case "WARNING":
            return '<span class="badge rounded-pill" style="display: block; background-color: #FAF6D4; color: #E6C26E">'+value+'</span>';
        case "IGNORED":
            return '<span class="badge rounded-pill" style="display: block; background-color: #474E56; color: #D4D4D6">'+value+'</span>';
        case "UNKNOWN":
            return '<span class="badge rounded-pill" style="display: block; background-color: #333; color: #888">'+value+'</span>';
        case "INFO":
            return '<span class="badge rounded-pill" style="display: block; background-color: #CEE6F2; color: #058DC7">'+value+'</span>';
        default:
            return value;
    }
}
